function Unauthorized() {
	return <h1>403 - Acesso não autorizado :(</h1>
}

export default Unauthorized
